import getUrl from 'lib/url'
import { stringify } from 'querystring'
import fetch from 'lib/decorated-fetch'

interface Params {
  type: '1' | '2'
  brand_id: string
  query: string
  series_id: string
}

const getCarFansOptions = async ({
  type,
  brand_id = '',
  query = '',
  series_id = '',
}: Params) => {
  const params = {
    query,
    brand_id,
    series_id,
    count: 100,
    offset: 0,
    type,
  }
  try {
    const json = await fetch(
      getUrl(
        `/motor/cheyou_community/api/get_community_by_name/?${stringify(
          params
        )}`
      ),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        body: stringify(params),
      }
    )
    return json.data?.hits
  } catch (error) {
    console.error('获取车友圈失败', error)
    return []
  }
}

export default getCarFansOptions
